module.exports = {
	"header": "Billing"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/billing.json5
// module id = 1919
// module chunks = 6